import React from 'react';

const Graph_Plotly_js = () => {
    return (
        <div>Graph_Plotly_js Component</div>
    );
}

export default Graph_Plotly_js;
